/**
 * Validators for partner configuration fields
 */
export const partnerConfigValidators = {
  package_partner: {
    required: true,
    validate: (value) => (value.trim() === "" ? "This field is required" : false),
  },
  receipt_partner: {
    required: true,
    validate: (value) => (value.trim() === "" ? "This field is required" : false),
  },
  generic_notification_partner: {
    required: true,
    validate: (value) => (value.trim() === "" ? "This field is required" : false),
  },
};
